import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { MicroFrontendResolver } from 'core/resolvers';
import { AccountComponent } from './account.component';

const accountRoutes: Routes = [
  {
    path: 'accounts',
    title: 'account.myAccount',
    canActivate: [ProfileGuard],
    data: { microfrontends: ['GlAccounts'] },
    resolve: { glaccounts: MicroFrontendResolver },
    children: [
      {
        path: 'my-account',
        title: '',
        component: AccountComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(accountRoutes)],
  exports: [RouterModule]
})
export class AccountRoutingModule {}
